module.exports = __webpack_public_path__ + "img/60c2586512b0a4.33959631.8c496b6f.png";